import { calendarItems, nowIso, today, weekStart, whenText } from '../../lib/calendar.js'
import { plannerHit } from '../../lib/planner.js'

const Fez = window.Fez;
if (!Fez) throw new Error('fez runtime not loaded: load fez (window.Fez) before component modules');

// --- calendar-search ---
let __fez_component_0;
{
const PAGE = 20
const LISTS = [
  { id: 'upcoming', title: 'Upcoming', past: false, none: 'Nothing coming up' },
  { id: 'past', title: 'Past', past: true, none: 'Nothing earlier' },
]
__fez_component_0 = class {
  PROPS = {
    q: String,
    calendars: Array,
    on_pick: { type: Function, state: true, default: () => {} },
    on_planner: { type: Function, state: true, default: () => {} },
  }

  init() {
    this.state.loading = true
    this.state.error = ''
    this.state.lists = { upcoming: { hits: [], more: false, busy: false }, past: { hits: [], more: false, busy: false } }
    this.state.seq = 0
  }

  onRefresh(props, changed) {
    if ('q' in changed) this.search()
  }

  page(list, offset) {
    return window.App.api('calendar/search', { q: this.props.q, past: list.past, offset, limit: PAGE, now: nowIso() }, { silent: true })
  }

  async search() {
    const seq = ++this.state.seq
    this.state.loading = true
    try {
      const [upcoming, past] = await Promise.all(LISTS.map((list) => this.page(list, 0)))
      if (seq !== this.state.seq) return
      this.state.lists = {
        upcoming: { hits: upcoming.items, more: upcoming.more, busy: false },
        past: { hits: past.items, more: past.more, busy: false },
      }
      this.state.error = ''
    } catch (error) {
      if (seq === this.state.seq) this.state.error = error.message
    } finally {
      if (seq === this.state.seq) this.state.loading = false
    }
  }

  async more(id) {
    const list = LISTS.find((entry) => entry.id === id)
    const held = this.state.lists[id]
    const seq = this.state.seq
    this.state.lists = { ...this.state.lists, [id]: { ...held, busy: true } }
    try {
      const next = await this.page(list, held.hits.length)
      if (seq !== this.state.seq) return
      this.state.lists = { ...this.state.lists, [id]: { hits: [...held.hits, ...next.items], more: next.more, busy: false } }
    } catch (error) {
      if (seq === this.state.seq) this.state.lists = { ...this.state.lists, [id]: { ...held, busy: false } }
      window.Toast.error(error.message)
    }
  }

  pick(id, key) {
    const row = this.state.sections.find((section) => section.id === id)?.rows.find((entry) => entry.key === key)
    if (row?.planner) this.state.on_planner(row.planner)
    else if (row) this.state.on_pick(row.item)
  }

  beforeRender() {
    // Search ignores the side list's toggles: every calendar shows its color here.
    const calendars = (this.props.calendars || []).map((calendar) => ({ ...calendar, shown: true, subscriptions: (calendar.subscriptions || []).map((subscription) => ({ ...subscription, shown: true })) }))
    const session = this.globalState.mailboxSession
    const thisWeek = weekStart(today())
    this.state.sections = LISTS.map((list) => {
      const held = this.state.lists[list.id]
      const rows = held.hits.flatMap((hit) => {
        if (!hit.event) {
          const planner = plannerHit(hit, thisWeek, list.past)
          if (!planner) return []
          return [{
            planner,
            key: planner.key,
            title: planner.title,
            when: planner.when,
            detail: planner.detail,
            snippet: planner.kind !== 'todo' && Boolean(planner.detail),
            icon: planner.kind === 'day' ? 'notebook' : planner.done ? 'check-circle' : 'circle',
            done: planner.done,
            colors: [],
            cancelled: false,
          }]
        }
        const item = calendarItems([hit.event], calendars, session)[0]
        if (!item) return []
        return [{
          item,
          key: item.key,
          title: item.title,
          when: whenText(item),
          detail: hit.snippet || item.location || '',
          snippet: Boolean(hit.snippet),
          icon: '',
          done: false,
          colors: item.colors,
          cancelled: item.cancelled,
        }]
      })
      return { ...list, more: held.more, busy: held.busy, rows }
    })
    this.state.empty = !this.state.loading && !this.state.error && this.state.sections.every((section) => !section.rows.length)
  }

  CSS = `:fez {
display:block;height:100%;overflow-y:auto;.cs{max-width:var(--content-width);margin:0 auto;padding:var(--space-4) var(--space-4) var(--space-10)}.cs-note{display:grid;place-items:center;height:100%;padding:var(--space-6)}.cs-section + .cs-section{margin-top:var(--space-6)}.cs-title{margin:0 0 var(--space-2);color:var(--color-text-subtle);font-size:var(--text-xs);font-weight:var(--weight-bold);letter-spacing:0.06em;text-transform:uppercase}.cs-none{margin:0;color:var(--color-text-muted);font-size:var(--text-sm)}.cs-row{display:flex;align-items:center;gap:var(--space-3);width:100%;padding:var(--space-2) var(--space-3);border:0;border-radius:var(--radius-md);background:transparent;color:var(--color-text);font:inherit;text-align:left;cursor:pointer;&:hover{background:var(--color-bg-hover)}&:focus-visible{outline:2px solid var(--color-focus);outline-offset:-2px}&.cancelled .cs-row-title,&.done .cs-row-title{text-decoration:line-through;opacity:0.7}}.cs-dots{display:inline-flex;flex:none;gap:3px;align-self:flex-start;min-width:20px;padding-top:6px}.cs-icon{display:inline-flex;flex:none;align-self:flex-start;width:20px;padding-top:2px;color:var(--color-accent)}.cs-dot{width:8px;height:8px;border-radius:var(--radius-full);background:var(--tag)}.cs-text{display:grid;flex:1;gap:1px;min-width:0}.cs-row-title{overflow:hidden;font-weight:var(--weight-semibold);text-overflow:ellipsis;white-space:nowrap}.cs-when,.cs-detail{overflow:hidden;color:var(--color-text-muted);font-size:var(--text-sm);text-overflow:ellipsis;white-space:nowrap}.cs-detail.snippet{font-style:italic}.cs-more{margin-top:var(--space-2);padding-left:var(--space-3)} :mobile {.cs{padding:var(--space-3) var(--space-2) var(--space-8)}}
}`

  HTML = `{#if state.error}
<div class="cs-note"><ui-empty icon="warning-circle" title="Could not search" text={state.error}></ui-empty></div>
{:else if state.loading}
<div class="cs-note"><ui-spinner size="lg"></ui-spinner></div>
{:else if state.empty}
<div class="cs-note"><ui-empty icon="magnifying-glass" title="Nothing matches" text="Every word must be in an event's title, place or description, a to-do, or a day's name and journal."></ui-empty></div>
{:else}
<div class="cs">
{#each state.sections as section}
<section class="cs-section" key={section.id}>
<h2 class="cs-title">{section.title}</h2>
{#each section.rows as row}
<button type="button" class="cs-row" class:cancelled={row.cancelled} class:done={row.done} key={row.key} onclick="fez.pick('{section.id}', '{row.key}')">
{#if row.icon}
<span class="cs-icon"><ui-icon name={row.icon} size="16"></ui-icon></span>
{:else}
<span class="cs-dots">{#each row.colors as color}<span class="cs-dot" style="--tag: var(--color-avatar-{color})"></span>{/each}</span>
{/if}
<span class="cs-text">
<span class="cs-row-title">{row.title}</span>
<span class="cs-when">{row.when}</span>
{#if row.detail}<span class="cs-detail" class:snippet={row.snippet}>{row.detail}</span>{/if}
</span>
</button>
{:else}
<p class="cs-none">{section.none}</p>
{/each}
{#if section.more}
<div class="cs-more"><ui-button size="sm" variant="ghost" label="Show more" :loading="section.busy" onclick="fez.more('{section.id}')"></ui-button></div>
{/if}
</section>
{/each}
</div>
{/if}`
};
}

Fez('calendar-search', __fez_component_0);

export default __fez_component_0;
